import { render } from "./SideBarComponent.vue?vue&type=template&id=141b6e10&scoped=true"
import script from "./SideBarComponent.vue?vue&type=script&lang=js"
export * from "./SideBarComponent.vue?vue&type=script&lang=js"

import "./SideBarComponent.vue?vue&type=style&index=0&id=141b6e10&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-141b6e10"]])

export default __exports__